// extracted by mini-css-extract-plugin
export default {"toggleImage":"round-button_toggleImage__r-Q11","toggleButton":"round-button_toggleButton__HblJv","jumpButton":"round-button_jumpButton__Soa5u"};